module.exports = __webpack_public_path__ + "img/img_32.688fa5b8.png";